(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["navika-product-story"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nv-size-guide')){
customElements.define('nv-size-guide',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;const dialog=this.querySelector('dialog');this.querySelector('.nv-size-guide__open').addEventListener('click',()=>dialog.showModal());this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});}
});}
  } catch(e) { console.error(e); }
})();

})();
